(ns hai.ui.request
  "The in-flight state of a named request, as the `:fetch` / `:resolve`
   effects record it at `[:fetch/request id :state]` and composers read it
   through the `:fetch/state` sub. A save event marks its own request in
   flight in the same `:db` write and does nothing while one is: the effect's
   `:fetch/start` is a dispatch of its own, so a second click queued before it
   ran would otherwise go out too.")

(defn in-flight?
  [db request-id]
  (= :start (get-in db [:fetch/request request-id :state])))

(defn mark-in-flight
  [db request-id]
  (assoc-in db [:fetch/request request-id :state] :start))
